
// used for making the prop types of this component
// reactstrap components
import { Container, Nav } from "reactstrap";
import { useT } from 'i18n';

const Footer = () => {
  const { t } = useT();
  return (
    <footer className="footer">
      <Container fluid>
       <Nav>
           {/* <NavItem>
            <NavLink href="https://www.panther7.com/?ref=bdr-user-archive-footer">Panther 7</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://www.panther7.com/presentation?ref=bdr-user-archive-footer">About Us</NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="https://www.panther7.com/blog?ref=bdr-user-archive-footer">Blog</NavLink>
          </NavItem> */} 
          <>
          </>
        </Nav>
        <div className="copyright">
          © {new Date().getFullYear()} 
          {" "}
          <a className="text-white"
            href="https://www.panther7.com/"
            target="_blank"
          >
             {t('pie.derechos')}
          </a>{" "}
          {t('pie.plataforma')}
        </div>
      </Container>
    </footer>
  );
}
 
export default Footer;

